<template>
  <div
    id="category"
    v-if="isMicroCategory && categoryBtnLocation"
    class="bg-documentGray"
    :class="'nav-category'"
    :style="`left: ${categoryBtnLocation}px`"
  >
    <div v-if="microCategoryList && categoryList">
      <div
        class="category"
        @mouseenter="toggleMenu('micro')"
        @mouseleave="toggleMenu('micro')"
      >
        {{ $t("30231") }}
        <i aria-hidden="true" class="material-icons mdc-button__icon mgr-16"
          >chevron_right</i
        >
        <ul
          v-if="isSkillPathMenu"
          class="sub-category-container"
          :class="{
            'sub-category-container__scrollBar': microCategoryList.length > 10,
          }"
        >
          <CategoryListComponent
            type="MULTI"
            :categoryList="microCategoryList"
            :categoryTotalPage="microCategoryTotalPage"
            parentClassList="t-body1 t-color-bodyGrayA font-r cursor-pointer l-spacing48 category-item"
            childClassList="t-body1 t-color-bodyGrayA font-r cursor-pointer l-spacing48"
            :isSkillPath="true"
          />
        </ul>
      </div>

      <div
        class="category"
        @mouseenter="toggleMenu('online')"
        @mouseleave="toggleMenu('online')"
      >
        {{ $t("30232") }}
        <i aria-hidden="true" class="material-icons mdc-button__icon mgr-16"
          >chevron_right</i
        >
        <ul
          v-if="isOnlineClassMenu"
          class="sub-category-container online"
          :class="{
            'sub-category-container__scrollBar': categoryList.length > 10,
          }"
        >
          <CategoryListComponent
            type="MULTI"
            :categoryList="categoryList"
            :categoryTotalPage="categoryTotalPage"
            parentClassList="t-body1 t-color-bodyGrayA font-r cursor-pointer l-spacing48 category-item"
            childClassList="t-body1 t-color-bodyGrayA font-r cursor-pointer l-spacing48"
          />
        </ul>
      </div>
    </div>
  </div>
</template>
  
  <script>
/**
 * 스킬패스 고객사 카테고리 리스트
 *
 * @author jaehyub.lee@emcast.com
 */
import { mapActions } from "vuex";

export default {
  components: {
    CategoryListComponent: () => import("./CategoryListComponent.vue"),
  },
  name: "MicroCategoryList",
  props: [
    "isMicroCategory",
    "isIdpService",
    "categoryList",
    "microCategoryList",
    "categoryBtnLocation",
    "categoryTotalPage",
    "microCategoryTotalPage",
  ],
  data() {
    return {
      isSkillPathMenu: false,
      isOnlineClassMenu: false,
    };
  },

  methods: {
    ...mapActions("nav", ["SET_IS_OPEN_CATEGORY"]),

    subjectList(id, name, type) {
      this.SET_IS_OPEN_CATEGORY(false);
      this.$router
        .push({
          name: "Subject",
          params: { id: id },
          query: { title: name, type, status: "LEARNING" },
        })
        .catch((err) => {});
    },

    toggleMenu(index) {
      switch (index) {
        case "micro":
          this.isSkillPathMenu = !this.isSkillPathMenu;
          break;

        case "online":
          this.isOnlineClassMenu = !this.isOnlineClassMenu;
          break;

        default:
          break;
      }
    },
  },
};
</script>
  
<style scoped>
.nav-category {
  position: fixed;
  width: 300px;
  height: auto;
  left: 0;
  top: 68px;
  z-index: 1001;
  padding: 8px 0;
  border-radius: 4px;
  font-family: "Noto Sans", "Noto Sans KR", "KhmerOS_sys", sans-serif;
}

.category-align-item {
  margin-left: 28px;
  margin-right: auto;
  padding: 4px;
  display: flex;
  justify-content: normal;
  flex-wrap: wrap;
  cursor: pointer;
}

.category {
  height: 48px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: var(--BodygrayA);
  display: flex;
  justify-content: space-between;
  font-weight: 400;
  cursor: pointer;
  position: relative;
}

.category:hover {
  font-weight: 900;
  color: var(--HeadlineBlack);
  background-color: var(--BlackHover);
}

.sub-category-container {
  position: absolute;
  margin-left: 299px;
  width: max-content;
  min-width: 280px;
  max-height: 550px;
  margin-top: -8px;
  top: 0px;
  left: 0;
  padding: 4px 0;
  border-radius: 4px;
  box-shadow: 0 3px 10px 0 var(--Shadow3);
  background-color: var(--DocumentWhite);
  overflow-y: auto;
  cursor: pointer;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow-x: hidden;
}
.sub-category-container::-webkit-scrollbar {
  display: none;
}
.sub-category-container__scrollBar {
  -ms-overflow-style: auto !important; /* IE and Edge */
  scrollbar-width: thin !important; /* Firefox */
}
.sub-category-container__scrollBar::-webkit-scrollbar {
  display: block !important; /* Chrome, Safari, Opera */
}
.online {
  margin-top: 4px;
}
</style>
  